/**
 * Captures the real GA4 client/session IDs and the actual consent state,
 * and stores them as cart attributes so the Shopify Custom Pixel
 * (docs/shopify-custom-pixel.js) can send begin_checkout/purchase hits
 * that GA4 can tie back to the visitor's existing session instead of
 * creating a brand-new "Unassigned" user. See:
 * docs/server-side-tracking-webhook-spec.md, section 4.
 */
(function () {
  var GA_SESSION_COOKIE = '_ga_TLY1BZ0KYR';
  var CACHE_KEY = 'ga_attribution_cart_attrs';

  function getCookie(name) {
    var pattern = '(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)';
    var match = document.cookie.match(new RegExp(pattern));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function getClientId() {
    var ga = getCookie('_ga');
    if (!ga) return null;
    // Format: GA1.1.<random>.<timestamp> (also seen: GA1.2.<random>.<timestamp>)
    var parts = ga.split('.');
    if (parts.length < 4) return null;
    return parts.slice(-2).join('.');
  }

  function getSessionId() {
    var gaSession = getCookie(GA_SESSION_COOKIE);
    if (!gaSession) return null;
    if (gaSession.indexOf('GS2.') === 0) {
      // Format: GS2.1.s<session_id>$o<nr>$g<engaged>$t<ts>$...
      var match = gaSession.match(/s(\d+)/);
      return match ? match[1] : null;
    }
    if (gaSession.indexOf('GS1.') === 0) {
      // Format: GS1.1.<session_id>.<nr>.<engaged>.<ts>
      var parts = gaSession.split('.');
      return parts.length >= 3 ? parts[2] : null;
    }
    return null;
  }

  function getConsent() {
    try {
      var consent = window.Shopify && window.Shopify.customerPrivacy &&
        window.Shopify.customerPrivacy.currentVisitorConsent();
      if (!consent) return null;
      var adGranted = consent.marketing === 'yes' ? '1' : '0';
      var analyticsGranted = consent.analytics === 'yes' ? '1' : '0';
      // Same G1<ad_storage><analytics_storage> shape the pixel already sends as `gcs`.
      return 'G1' + adGranted + analyticsGranted;
    } catch (e) {
      return null;
    }
  }

  function syncCartAttributes() {
    var clientId = getClientId();
    var sessionId = getSessionId();
    var consent = getConsent();

    // Nothing useful to attach yet (e.g. analytics_storage still denied, no _ga cookie).
    if (!clientId && !sessionId && !consent) return;

    var attributes = {};
    if (clientId) attributes.ga_client_id = clientId;
    if (sessionId) attributes.ga_session_id = sessionId;
    if (consent) attributes.ga_consent = consent;

    var serialized = JSON.stringify(attributes);
    if (sessionStorage.getItem(CACHE_KEY) === serialized) return;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
      keepalive: true,
    })
      .then(function (res) {
        if (res.ok) sessionStorage.setItem(CACHE_KEY, serialized);
      })
      .catch(function () {});
  }

  // Initial attempt once the page settles (mirrors the theme's own
  // wait_for_update: 2000 for Consent Mode) - covers returning visitors
  // and regions where consent is granted by default.
  setTimeout(syncCartAttributes, 2200);

  // Re-sync whenever Shopify's Customer Privacy API reports a consent
  // change (CookieFirst forwards its choices into this API via
  // sh-customer-privacy.js) - this is the moment analytics_storage may
  // flip to granted and the _ga cookie first becomes available.
  document.addEventListener('visitorConsentCollected', syncCartAttributes);
})();
